export { EventBus };


const EventBus = new Vue();
